import InstructorStudentAnalysis from "@/components/instructor/InstructorStudentAnalysis";

export default function InstructorAnalytics() {
  return (
    <div className="container mx-auto px-4 py-8">
      <header className="mb-6">
        <h1 className="text-3xl font-bold">Analytics</h1>
        <p className="text-muted-foreground">Student performance breakdown across your tests.</p>
      </header>
      <InstructorStudentAnalysis />
    </div>
  );
}
